import React, { useState } from "react"
import "../styles.css"
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';
import Zoom from "@material-ui/core/Zoom"

var CreateArea = function(props){
  const [isExpanded, setExpanded] = useState(false);

const[note,setNote] =useState({

title:"",
content:""

});


var handleChange =function(event){

const{name,value} =event.target

setNote((prevNote)=>{

return {
...prevNote,

[name] : value
}
})


}

var submitNote =function(event){
  props.onAdd(note);
  setNote({
    title: "",
    content: ""
  });
  event.preventDefault();

}

function expand() {
  setExpanded(true);
}


return (

    <div>
     
     <form className="create-note">
     {isExpanded && (
          <input
            name="title"
            onChange={handleChange}
            value={note.title}
            placeholder="Title"
          />
        )}

        <textarea
          name="content"
          onClick={expand}
          onChange={handleChange}
          value={note.content}
          placeholder="Take a note..."
          rows={isExpanded ? 3 : 1}
        />
        <Zoom in={isExpanded}><Fab onClick={submitNote} className="add"><AddIcon /></Fab></Zoom> 
     </form>


    </div>


)



}

export default CreateArea